import { render, staticRenderFns } from "./InitComponent.vue?vue&type=template&id=28be82cc&"
import script from "./InitComponent.vue?vue&type=script&lang=js&"
export * from "./InitComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports